export const GRAPHQL_DEFAULT_HEADERS: Record<string, string> = {
	'Content-Type': 'application/json'
};
